/* =====================================================================
   Accueil « avant lancement » v6, FR / IT / ES (sections/mng-home-v6.liquid). IT / ES : textes et liste Klaviyo lus dans le
   JSON #mng-home-v6-i18n posé par la section (absent en FR : le français ne change pas).
   Scripts de la maquette HOME-MNG-REFONTE-2026-09-25/maquette-v6-vip/index.html, branchés sur le vrai site :
     1. hôte des éléments fixes (barre VIP collante) enfant de <body>
     2. barre VIP collante (retirée quand la mini-barre panier est affichée : une seule barre en bas)
     3. apparitions (.rvl), compteurs, inclinaison au survol
     4. compte à rebours jusqu'à l'ouverture VIP
     5. liste VIP : même envoi Klaviyo que /pages/liste-vip, liste « Caps · VIP Base » StbrFJ, src=home, sans signal pub ; succès + confettis
     6. ajout au panier : [data-qs] ouvre la fenêtre d'ajout rapide des cartes (mng-collection-v3.js),
        accessoires : POST /cart/add.js puis « cart:updated » (tiroir du thème)
     7. vidéos en boucle : lecture seulement quand elles sont visibles
   Tout est limité à #mng-home-v6 : aucune requête sur le reste de la page, sauf l'icône panier et le pied de page du thème.
   ===================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('mng-home-v6');
  if (!root || root.getAttribute('data-hv6-ready') === '1') return;
  root.setAttribute('data-hv6-ready', '1');
  root.classList.add('ready');

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;
  /* langue : textes et liste Klaviyo pour l'italien et l'espagnol (JSON posé par la section hors FR ; absent en FR) */
  var I18N = {};
  try { var i18nEl = document.getElementById('mng-home-v6-i18n'); if (i18nEl) I18N = JSON.parse(i18nEl.textContent) || {}; }
  catch (e) { console.error('[Accueil] textes de langue illisibles', e); }
  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }

  /* ---------- 1. hôte des éléments fixes ---------- */
  var host = document.createElement('div');
  host.className = 'mnghv6 mnghv6-host';
  host.id = 'mng-home-v6-host';
  $$('[data-hv6-fixed]').forEach(function (el) { host.appendChild(el); });
  document.body.appendChild(host);

  /* ---------- 2. barre VIP collante ---------- */
  (function () {
    var s = host.querySelector('#sticky');
    var h = root.querySelector('.hero');
    var p = root.querySelector('#vip');
    var q = root.querySelector('.final-form');
    var f = document.querySelector('.mng-ft') || document.querySelector('.shopify-section-group-footer-group');
    if (!s || !hasIO) return;
    var v = { h: 1, p: 0, f: 0, q: 0 };
    /* une seule barre en bas à la fois : la mini-barre panier des cartes (mng-collection-v3.js, classe « on »,
       affichée en téléphone seulement) a la priorité sur la barre VIP */
    var mbs = [].slice.call(document.querySelectorAll('#mng-home-v6 .mngc3-mb, .mngc3-host .mngc3-mb'));
    function panierVisible() {
      for (var i = 0; i < mbs.length; i++) { if (mbs[i].classList.contains('on') && getComputedStyle(mbs[i]).display !== 'none') return true; }
      return false;
    }
    mbs.forEach(function (m) { new MutationObserver(function () { u(); }).observe(m, { attributes: true, attributeFilter: ['class'] }); });
    window.addEventListener('resize', function () { u(); });
    function u() {
      var on = !v.h && !v.p && !v.f && !v.q && !panierVisible();
      s.classList.toggle('on', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.classList.toggle('mnghv6-sticky-on', on);
    }
    if (q) new IntersectionObserver(function (e) { v.q = e[0].isIntersecting; u(); }).observe(q);
    if (h) new IntersectionObserver(function (e) { v.h = e[0].isIntersecting; u(); }).observe(h);
    if (p) new IntersectionObserver(function (e) { v.p = e[0].isIntersecting; u(); }, { threshold: .2 }).observe(p);
    if (f) new IntersectionObserver(function (e) { v.f = e[0].isIntersecting; u(); }).observe(f);
  })();

  /* ---------- 3. apparitions, compteurs, inclinaison ---------- */
  (function () {
    var els = $$('.rvl,[data-rv-children] li');
    if (!hasIO || reduce) { els.forEach(function (e) { e.classList.add('in'); }); }
    else {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
      }, { threshold: .18, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (e) { io.observe(e); });
    }
    var fmt = function (v, d) { return v.toLocaleString(I18N.num || 'fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d }); };
    $$('[data-count]').forEach(function (el) {
      var to = parseFloat(el.dataset.count), d = +(el.dataset.dec || 0), done = false;
      if (reduce || !hasIO || el.closest('.tpw-n, .tpw-r')) return; /* TXT-15 (29/09) : 4,8/5 et 50 000 affichés tels quels, jamais de valeur intermédiaire */
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting || done) return;
        done = true; var t0 = null;
        function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(to * e, d); if (k < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      }, { threshold: .6 });
      o.observe(el);
    });
    if (!reduce && window.matchMedia && window.matchMedia('(hover:hover)').matches) {
      $$('.tilt').forEach(function (c) {
        c.addEventListener('pointermove', function (ev) {
          var r = c.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5;
          c.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg');
        });
        c.addEventListener('pointerleave', function () { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); });
      });
    }
  })();

  /* ---------- 4. compte à rebours vers l'ouverture VIP (heure de Paris) ---------- */
  (function () {
    var cs = $$('.count[data-until]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      cs.forEach(function (c) {
        var d = Math.max(0, new Date(c.dataset.until) - new Date()), b = c.querySelectorAll('b');
        if (b.length < 4) return;
        b[0].textContent = pad(Math.floor(d / 864e5)); b[1].textContent = pad(Math.floor(d / 36e5) % 24);
        b[2].textContent = pad(Math.floor(d / 6e4) % 60); b[3].textContent = pad(Math.floor(d / 1e3) % 60);
      });
    }
    if (cs.length) { tick(); setInterval(tick, 1000); }
  })();

  /* ---------- 5. liste VIP ----------
     Même envoi que /pages/liste-vip (sections/lp-vip-caps-v2.liquid, en ligne le 26/09), dans sa branche « cliqueurs d'emails » :
     API client publique Klaviyo, compte XDHDUN, révision 2024-10-15, source « LP VIP Mush Caps », liste « Caps · VIP Base » StbrFJ
     (la LP y met les visiteurs arrivés avec ?src= ; flow d'accueil « Caps · M0 accueil VIP Base » Xj2MWG, déclenché par la liste).
     Décision d'Alex (26/09) : depuis l'accueil, TOUJOURS StbrFJ, jamais « VIP Paid » Xi5hVW ; propriété src = « home » à la place
     de l'identifiant d'email ; AUCUN signal d'inscription (ni liste_vip_inscription, ni Shopify.analytics, ni Meta CompleteRegistration)
     pour ne pas fausser la campagne lead gen. Mémoire UTM identique (localStorage mng_vip_pub, 7 jours, cookies marketing acceptés).
     Pas de redirection vers la page merci : état de succès et confettis de la maquette. */
  (function () {
    function lpv2ConsentMk() {
      try {
        if (window.Cookiebot && window.Cookiebot.consent) return !!window.Cookiebot.consent.marketing;
        var cp = window.Shopify && window.Shopify.customerPrivacy; return !!(cp && cp.marketingAllowed && cp.marketingAllowed());
      } catch (e) { return false; }
    }

    var KL_COMPANY = 'XDHDUN';
    var KL_LIST = 'StbrFJ';     /* « Caps · VIP Base » (celle des cliqueurs d'emails), jamais « VIP Paid » Xi5hVW */
    /* italien / espagnol : listes de /it|es/pages/liste-vip (« Caps · VIP Meta IT » XPw5jk, « Caps · VIP Meta ES » SmBasv), propriété Language */
    var KL_LISTES_LANGUE = { it: 'XPw5jk', es: 'SmBasv' };
    if (I18N.lang) { KL_LIST = KL_LISTES_LANGUE[I18N.lang]; if (!KL_LIST) console.error('[Accueil VIP] pas de liste Klaviyo pour la langue', I18N.lang); }
    var KL_REV = '2024-10-15';
    var KL_SOURCE = 'LP VIP Mush Caps';
    var KL_SRC = 'home';        /* propriété src : identifiant de l'email sur la LP, « home » ici */
    var ABC = 'abcdefghjkmnpqrstuvwxyz23456789';

    function monCode() {
      var r = '';
      try { r = localStorage.getItem('mng_vip_ref') || ''; } catch (e) {}
      if (/^[a-z0-9]{6}$/.test(r)) return r;
      r = '';
      var c = window.crypto || window.msCrypto;
      if (c && c.getRandomValues) { var a = new Uint32Array(6); c.getRandomValues(a); for (var i = 0; i < 6; i++) r += ABC[a[i] % ABC.length]; }
      else { for (var j = 0; j < 6; j++) r += ABC[Math.floor(Math.random() * ABC.length)]; }
      try { localStorage.setItem('mng_vip_ref', r); } catch (e) {}
      return r;
    }
    function utms() {
      var q = new URLSearchParams(location.search), o = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = q.get(k); if (v) o[k] = String(v).slice(0, 120);
      });
      try {
        var fb = q.get('fbclid');
        if (Object.keys(o).length || fb) { if (lpv2ConsentMk()) localStorage.setItem('mng_vip_pub', JSON.stringify({ u: o, t: Date.now() })); }
        else { var m = JSON.parse(localStorage.getItem('mng_vip_pub') || 'null'); if (m && m.u && Date.now() - m.t < 6048e5) { o = m.u; o.utm_rappel = '1'; } }
      } catch (e) {}
      return o;
    }
    try { utms(); } catch (e) {}
    window.addEventListener('CookiebotOnAccept', function () { try { utms(); } catch (e) {} });

    // 29/09 (suivi WhatsApp) : même règle que la LP VIP : code à 6 caractères ou ID Klaviyo à 26 (boutons WhatsApp
    // des emails), repris de l'onglet ou du parrain gardé 7 jours par la LP (localStorage mng_vip_parrain).
    function refParrain(v) { v = String(v || '').trim(); if (/^[a-z0-9]{6}$/i.test(v)) return v.toLowerCase(); if (/^[0-9a-hjkmnp-tv-z]{26}$/i.test(v)) return v.toUpperCase(); return ''; }
    var REF = refParrain(new URLSearchParams(location.search).get('ref'));
    if (REF) {
      try { sessionStorage.setItem('mng_vip_referrer', REF); } catch (e) {}
      try { if (lpv2ConsentMk()) localStorage.setItem('mng_vip_parrain', JSON.stringify({ r: REF, t: Date.now() })); } catch (e) {}
    } else {
      try { REF = refParrain(sessionStorage.getItem('mng_vip_referrer')); } catch (e) { REF = ''; }
      if (!REF) { try { var mp = JSON.parse(localStorage.getItem('mng_vip_parrain') || 'null'); if (mp && Date.now() - mp.t < 6048e5) REF = refParrain(mp.r); } catch (e) { REF = ''; } }
    }

    var cols = ['#F0D96A', '#EFACE4', '#F3EEEA', '#A180CA'];
    function succes(f) {
      f.classList.remove('err'); f.classList.add('ok');
      if (!f.classList.contains('club-form')) $$('.vip-form:not(.club-form)').forEach(function (g) { g.classList.add('ok'); });
      if (reduce) return;
      for (var i = 0; i < 26; i++) {
        var c = document.createElement('i'); c.className = 'confetti';
        var a = Math.random() * Math.PI * 2, r = 90 + Math.random() * 160;
        c.style.setProperty('--x', Math.cos(a) * r + 'px'); c.style.setProperty('--y', (Math.sin(a) * r - 60) + 'px');
        c.style.setProperty('--rz', (Math.random() * 720 - 360) + 'deg'); c.style.setProperty('--c', cols[i % 4]);
        f.appendChild(c); setTimeout(function (x) { return function () { x.remove(); }; }(c), 1200);
      }
    }
    function erreur(f, txt) {
      var e = f.querySelector('.vf-err');
      if (!e) { e = document.createElement('p'); e.className = 'vf-err'; e.setAttribute('role', 'alert'); f.querySelector('.vf-row').insertAdjacentElement('afterend', e); }
      e.textContent = txt; e.hidden = false;
    }
    function inscrire(f, email) {
      var btn = f.querySelector('button[type="submit"]');
      var e0 = f.querySelector('.vf-err'); if (e0) e0.hidden = true;
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true;

      var props = { ref: monCode(), source: KL_SOURCE, src: KL_SRC };
      if (I18N.lang) props.Language = I18N.lang;
      if (REF) props.referrer = REF;
      var u = utms(); for (var k in u) props[k] = u[k];

      var corps = { data: { type: 'subscription',
        attributes: { custom_source: KL_SOURCE,
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } } } };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_COMPANY, {
        method: 'POST', mode: 'cors',
        headers: { 'Content-Type': 'application/json', 'revision': KL_REV },
        body: JSON.stringify(corps)
      }).then(function (r) {
        if (r.status === 202 || (r.status >= 200 && r.status < 300)) {
          btn.removeAttribute('aria-busy'); btn.disabled = false;
          try { sessionStorage.setItem('mng_vip_email', email); } catch (err) {}
          /* aucun signal publicitaire depuis l'accueil (décision d'Alex du 26/09) */
          succes(f);
          return;
        }
        return r.text().then(function (t) { throw new Error('HTTP ' + r.status + ' ' + t.slice(0, 300)); });
      }).catch(function (err) {
        btn.removeAttribute('aria-busy'); btn.disabled = false;
        erreur(f, I18N.err_vip || "Votre inscription n'a pas pu être enregistrée. Vérifiez votre connexion et réessayez, ou écrivez-nous à contact@mushngo.com.");
        if (window.console) console.error('[Accueil VIP] Klaviyo', err);
      });
    }

    $$('.vip-form').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = f.querySelector('button[type="submit"]');
        if (btn && btn.disabled) return;
        var v = f.querySelector('input[type="email"]').value.trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { f.classList.remove('err'); void f.offsetWidth; f.classList.add('err'); return; }
        f.classList.remove('err');
        inscrire(f, v);
      });
    });
  })();

  /* ---------- 6. ajout au panier ---------- */
  (function () {
    function cartIcon() {
      var a = document.getElementById('cart-icon-bubble'), b = document.getElementById('cart-icon-bubble-mobile');
      if (a && a.offsetParent !== null) return a;
      if (b && b.offsetParent !== null) return b;
      return null;
    }
    function fly(btn) {
      var src = btn.dataset.img, cart = cartIcon();
      if (!src || !cart || reduce || !Element.prototype.animate) return;
      var a = btn.getBoundingClientRect(), b = cart.getBoundingClientRect();
      var im = new Image(); im.src = src; im.alt = '';
      im.style.cssText = 'position:fixed;z-index:80;pointer-events:none;height:90px;width:auto;max-width:none;left:' + (a.left + a.width / 2 - 35) + 'px;top:' + (a.top - 60) + 'px';
      host.appendChild(im);
      var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top - 15);
      var an = im.animate([
        { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
        { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 120) + 'px) scale(.7) rotate(-20deg)', opacity: 1, offset: .5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15) rotate(-40deg)', opacity: .4 }
      ], { duration: 900, easing: 'cubic-bezier(.5,0,.3,1)' });
      an.onfinish = function () { im.remove(); };
    }
    /* tuiles Café / Choco et « Leur préféré » : fenêtre d'ajout rapide des cartes de la collection */
    $$('[data-qs]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var t = root.querySelector('[data-mngc3] [data-add="' + b.dataset.qs + '"]');
        if (t) t.click(); else console.error('[Accueil] fenêtre d\'ajout rapide introuvable', b.dataset.qs);
      });
    });
    /* accessoires : ajout direct (produit sans option) */
    $$('.add[data-variant]').forEach(function (b) {
      var lab = b.textContent;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (b.classList.contains('added') || b.getAttribute('aria-busy') === 'true') return;
        var id = parseInt(b.dataset.variant, 10);
        if (!id) { console.error('[Accueil] variante absente', b); return; }
        b.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) {
          return r.ok ? r.json() : r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || ('HTTP ' + r.status)); });
        }).then(function () {
          b.removeAttribute('aria-busy');
          b.classList.add('added'); b.textContent = b.classList.contains('add-s') ? '✓' : (I18N.added || 'Ajouté ✓');
          fly(b);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () { b.classList.remove('added'); b.textContent = lab; }, 1800);
        }).catch(function (err) {
          b.removeAttribute('aria-busy');
          console.error('[Accueil] ajout au panier', err);
          b.textContent = I18N.err_add || 'Erreur, réessayez';
          setTimeout(function () { b.textContent = lab; }, 2500);
        });
      });
    });
  })();

  /* ---------- 7. vidéos en boucle : lecture quand visibles, pause sinon ---------- */
  (function () {
    var vids = $$('video[data-hv6-auto]');
    function play(v) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function (e) {
        /* lecture automatique refusée (mode économie d'énergie) ou interrompue par une pause : l'affiche reste */
        if (e && (e.name === 'NotAllowedError' || e.name === 'AbortError')) return;
        console.error('[Accueil] vidéo', e);
      });
    }
    if (!vids.length) return;
    if (!hasIO) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) play(x.target); else if (!x.target.paused) x.target.pause(); });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  })();
})();
